(function () {
  if (window.__kvCardAudio) return;
  window.__kvCardAudio = true;

  function setPlay(button, isPlaying) {
    button.classList.toggle("is-playing", isPlaying);
    button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
  }

  function setBar(player, percentage) {
    var fill = player.querySelector(".kv-card__player-fill");
    if (fill) fill.style.width = percentage + "%";
    var progress = player.querySelector(".kv-card__player-progress");
    if (progress) progress.setAttribute("aria-valuenow", String(Math.round(percentage)));
  }

  var animationFrame = null;
  var activePlayer = null;
  var abContext = null;

  function abState(player) {
    if (!player.__kvCardAB) {
      player.__kvCardAB = { pair: null, sources: null, gains: null, offset: 0,
        playing: false, loading: false, token: 0, mode: "on", duration: 0, fade: null };
    }
    return player.__kvCardAB;
  }

  function selectedTrack(player) {
    var select = player.querySelector(".kv-card__track-select");
    var option = select && select.options[select.selectedIndex];
    var data = player.querySelector(".kv-card__ab-data");
    var audio = player.querySelector("audio");
    return { on: option ? option.value : audio.src,
      bypass: option ? option.getAttribute("data-bypass") : data && data.getAttribute("data-bypass") };
  }

  function syncAB(player) {
    var ab = player.querySelector(".kv-card__ab");
    if (!ab) return;
    var paired = !!selectedTrack(player).bypass;
    ab.hidden = !paired;
    ab.querySelectorAll("button").forEach(function (button) {
      var on = button.getAttribute("data-kv-card-ab") === abState(player).mode;
      button.classList.toggle("is-active", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function playhead(state) {
    if (!state.playing || !state.duration) return state.offset;
    return Math.max(0, abContext.currentTime - state.startTime) % state.duration;
  }

  function releaseSources(state) {
    if (!state.sources) return;
    state.sources.forEach(function (source) {
      try { source.stop(); } catch (_) {}
      source.disconnect();
    });
    state.gains.forEach(function (gain) { gain.disconnect(); });
    state.sources = null;
    state.gains = null;
    state.fade = null;
  }

  function stopAB(player, reset, discard) {
    var state = player.__kvCardAB;
    if (!state) return;
    if (state.playing) state.offset = playhead(state);
    state.playing = false;
    state.loading = false;
    state.token++;
    if (state.controller) state.controller.abort();
    state.controller = null;
    releaseSources(state);
    if (reset) state.offset = 0;
    if (discard) { state.pair = null; state.duration = 0; }
    var button = player.querySelector(".kv-card__play-btn");
    if (button) setPlay(button, false);
    if (activePlayer === player) stopTick();
    if (reset) setBar(player, 0);
  }

  function context() {
    if (!abContext || abContext.state === "closed") {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) throw new Error("Web Audio is unavailable");
      abContext = new AC();
    }
    return abContext;
  }

  function startAB(player, state) {
    var ctx = context();
    var when = ctx.currentTime + 0.015;
    var duration = state.duration;
    var offset = state.offset % duration;
    var gains = [ctx.createGain(), ctx.createGain()];
    var sources = [ctx.createBufferSource(), ctx.createBufferSource()];
    gains.forEach(function (gain, i) {
      gain.gain.value = (state.mode === "on" ? i === 0 : i === 1) ? 1 : 0;
      gain.connect(ctx.destination);
      sources[i].buffer = i === 0 ? state.pair.on : state.pair.bypass;
      sources[i].loop = true;
      sources[i].loopStart = 0;
      sources[i].loopEnd = duration;
      sources[i].connect(gain);
    });
    state.sources = sources;
    state.gains = gains;
    state.startTime = when - offset;
    try { sources.forEach(function (source) { source.start(when, offset); }); }
    catch (error) { releaseSources(state); throw error; }
    state.playing = true;
    setPlay(player.querySelector(".kv-card__play-btn"), true);
    startTick(player);
  }

  async function playAB(player) {
    var state = abState(player);
    var track = selectedTrack(player);
    var token = ++state.token;
    state.loading = true;
    var status = player.querySelector(".kv-card__player-error");
    if (status) { status.textContent = ""; status.hidden = true; }
    stopAll(player);
    document.dispatchEvent(new CustomEvent("kiive:audio-active", { detail: { source: player } }));
    try {
      var ctx = context();
      if (ctx.state === "suspended") await ctx.resume();
      if (!state.pair) {
        var controller = new AbortController();
        state.controller = controller;
        var buffers = await Promise.all([track.on, track.bypass].map(async function (url) {
          var response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error("HTTP " + response.status + " for " + url);
          return ctx.decodeAudioData(await response.arrayBuffer());
        }));
        if (token !== state.token) return;
        state.pair = { on: buffers[0], bypass: buffers[1] };
        state.duration = Math.min(buffers[0].duration, buffers[1].duration);
        if (!Number.isFinite(state.duration) || state.duration <= 0) throw new Error("Empty audio pair");
      }
      if (token !== state.token) return;
      state.controller = null;
      state.loading = false;
      startAB(player, state);
    } catch (error) {
      if (token !== state.token) return;
      stopAB(player, false, true);
      if (status) { status.textContent = "Audio unavailable. Choose another source."; status.hidden = false; }
      console.error("Kiive card preview: could not load ON/BYPASS audio", error);
    }
  }

  function fadeAB(state) {
    if (!state.playing || !state.gains) return;
    var now = abContext.currentTime;
    var target = state.mode === "on" ? [1, 0] : [0, 1];
    var previous = state.fade;
    var from = state.gains.map(function (gain, i) {
      if (!previous) return gain.gain.value;
      var fraction = Math.max(0, Math.min(1, (now - previous.at) / 0.025));
      return previous.from[i] + (previous.to[i] - previous.from[i]) * fraction;
    });
    state.gains.forEach(function (gain, i) {
      gain.gain.cancelScheduledValues(now);
      gain.gain.setValueAtTime(from[i], now);
      gain.gain.linearRampToValueAtTime(target[i], now + 0.025);
    });
    state.fade = { at: now, from: from, to: target };
  }

  function changeTrack(player, autoplay) {
    var state = player.__kvCardAB;
    var audio = player.querySelector("audio");
    if (state) stopAB(player, true, true);
    audio.pause();
    audio.src = selectedTrack(player).on;
    audio.currentTime = 0;
    setBar(player, 0);
    var status = player.querySelector(".kv-card__player-error");
    if (status) { status.textContent = ""; status.hidden = true; }
    if (state) state.mode = "on";
    syncAB(player);
    if (!autoplay) return;
    if (selectedTrack(player).bypass) playAB(player);
    else audio.play().then(function () {
      setPlay(player.querySelector(".kv-card__play-btn"), true);
      startTick(player);
    }).catch(function () {});
  }

  function tick() {
    if (!activePlayer) return;
    var state = activePlayer.__kvCardAB;
    if (state && state.playing) {
      setBar(activePlayer, (playhead(state) / state.duration) * 100);
      animationFrame = requestAnimationFrame(tick);
      return;
    }
    var audio = activePlayer.querySelector("audio");
    if (audio && !audio.paused && audio.duration) {
      setBar(activePlayer, (audio.currentTime / audio.duration) * 100);
    }
    animationFrame = requestAnimationFrame(tick);
  }

  function startTick(player) {
    activePlayer = player;
    if (animationFrame) cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(tick);
  }

  function stopTick() {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    animationFrame = null;
    activePlayer = null;
  }

  function stopAll(keepAudio, reset) {
    if (reset === undefined) reset = true;
    document.querySelectorAll(".kv-card__player").forEach(function (player) {
      var audio = player.querySelector("audio");
      var button = player.querySelector(".kv-card__play-btn");
      if (player !== keepAudio && audio !== keepAudio && player.__kvCardAB) {
        if (player.__kvCardAB.playing || player.__kvCardAB.loading) stopAB(player, reset, true);
        else player.__kvCardAB.pair = null;
      }
      if (audio && audio !== keepAudio && !audio.paused) {
        audio.pause();
        if (reset) audio.currentTime = 0;
        if (button) setPlay(button, false);
        if (reset) setBar(player, 0);
        if (activePlayer === player) stopTick();
      }
    });
  }

  /* A removed card's Web Audio sources outlive its DOM unless explicitly
     stopped. Shopify section refreshes and dynamic grids use this path. */
  function releaseCards(scope) {
    if (!scope) return;
    var players = [];
    if (scope.matches && scope.matches(".kv-card__player")) players.push(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(".kv-card__player").forEach(function (player) { players.push(player); });
    players.forEach(function (player) {
      if (player.__kvCardAB) stopAB(player, true, true);
      var audio = player.querySelector("audio");
      if (audio && !audio.paused) audio.pause();
      if (activePlayer === player) stopTick();
      var button = player.querySelector(".kv-card__play-btn");
      if (button) setPlay(button, false);
    });
  }

  /* A card audio element is the source ID. This also covers automatic track
     advance and other programmatic play calls, not only button clicks. */
  document.addEventListener("play", function (event) {
    var audio = event.target;
    if (!audio.classList || !audio.classList.contains("kv-card__audio")) return;
    stopAll(audio);
    document.dispatchEvent(new CustomEvent("kiive:audio-active", { detail: { source: audio } }));
  }, true);

  document.addEventListener("kiive:audio-active", function (event) {
    var source = event.detail && event.detail.source;
    stopAll(source, false);
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".kv-card__play-btn");
    if (!button) return;
    event.preventDefault();

    var player = button.closest(".kv-card__player");
    var audio = player && player.querySelector("audio");
    if (!audio) return;

    if (selectedTrack(player).bypass) {
      var state = abState(player);
      if (state.playing || state.loading) stopAB(player, false, false);
      else playAB(player);
      return;
    }
    stopAll(audio);
    if (audio.paused) {
      audio
        .play()
        .then(function () {
          setPlay(button, true);
          startTick(player);
        })
        .catch(function () {});
    } else {
      audio.pause();
      setPlay(button, false);
      stopTick();
    }
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".kv-card__skip-btn");
    if (!button) return;
    event.preventDefault();

    var player = button.closest(".kv-card__player");
    var select = player && player.querySelector(".kv-card__track-select");
    var audio = player && player.querySelector("audio");
    if (!select || !audio) return;

    var nextIndex = (select.selectedIndex + 1) % select.options.length;
    select.selectedIndex = nextIndex;
    changeTrack(player, true);
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest(".kv-card__track-select");
    if (!select) return;

    var player = select.closest(".kv-card__player");
    var audio = player && player.querySelector("audio");
    if (!audio) return;

    var state = player.__kvCardAB;
    changeTrack(player, !audio.paused || !!(state && (state.playing || state.loading)));
  });

  document.addEventListener(
    "ended",
    function (event) {
      if (
        !event.target.classList ||
        !event.target.classList.contains("kv-card__audio")
      ) {
        return;
      }

      var player = event.target.closest(".kv-card__player");
      var playButton =
        player && player.querySelector(".kv-card__play-btn");
      var select = player && player.querySelector(".kv-card__track-select");

      if (select) {
        var nextIndex = select.selectedIndex + 1;
        if (nextIndex < select.options.length) {
          select.selectedIndex = nextIndex;
          changeTrack(player, true);
          return;
        }
      }

      if (playButton) setPlay(playButton, false);
      setBar(player, 0);
      stopTick();
    },
    true
  );

  document.addEventListener("click", function (event) {
    var progress = event.target.closest(".kv-card__player-progress");
    if (!progress) return;

    var player = progress.closest(".kv-card__player");
    var audio = player && player.querySelector("audio");
    if (!audio) return;

    var state = player.__kvCardAB;
    var duration = selectedTrack(player).bypass ? state && state.duration : audio.duration;
    if (!duration) return;

    var rectangle = progress.getBoundingClientRect();
    var percentage = (event.clientX - rectangle.left) / rectangle.width;
    percentage = Math.max(0, Math.min(1, percentage));
    if (selectedTrack(player).bypass) {
      state.offset = percentage * duration;
      if (state.playing) {
        releaseSources(state);
        state.playing = false;
        startAB(player, state);
      }
    } else audio.currentTime = percentage * duration;
    setBar(player, percentage * 100);
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-kv-card-ab]");
    if (!button) return;
    event.preventDefault();
    var player = button.closest(".kv-card__player");
    if (!player || !selectedTrack(player).bypass) return;
    var state = abState(player);
    state.mode = button.getAttribute("data-kv-card-ab");
    syncAB(player);
    fadeAB(state);
  });

  document.addEventListener("keydown", function (event) {
    var progress = event.target.closest(".kv-card__player-progress");
    if (!progress || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    var player = progress.closest(".kv-card__player");
    var state = player.__kvCardAB;
    var audio = player.querySelector("audio");
    var duration = selectedTrack(player).bypass ? state && state.duration : audio.duration;
    if (!duration) return;
    event.preventDefault();
    var current = selectedTrack(player).bypass ? playhead(state) : audio.currentTime;
    var target = event.key === "Home" ? 0 : event.key === "End" ? duration :
      Math.max(0, Math.min(duration, current + (event.key === "ArrowRight" ? 5 : -5)));
    if (selectedTrack(player).bypass) {
      state.offset = target % duration;
      if (state.playing) { releaseSources(state); state.playing = false; startAB(player, state); }
    } else audio.currentTime = target;
    setBar(player, (target / duration) * 100);
  });

  /* Smart product artwork -------------------------------------------------
     Product images often use square transparent canvases even when the GUI
     itself is a shallow horizontal rack unit. Measure the visible alpha bounds
     on a small, lazy-loaded copy and fit each product independently. */
  var smartBoundsCache = new Map();
  var smartResizeTimer = null;

  function smartClamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function smartFallbackBounds(image) {
    return {
      x: 0,
      y: 0,
      width: image.naturalWidth || 1,
      height: image.naturalHeight || 1,
      canvasWidth: image.naturalWidth || 1,
      canvasHeight: image.naturalHeight || 1,
    };
  }

  function smartReadBounds(image) {
    var key = image.currentSrc || image.src;
    if (smartBoundsCache.has(key)) return smartBoundsCache.get(key);

    var promise = new Promise(function (resolve) {
      function measurePixels() {
        if (!image.naturalWidth || !image.naturalHeight) {
          resolve(smartFallbackBounds(image));
          return;
        }

        var maximumSample = 160;
        var sampleRatio = Math.min(
          1,
          maximumSample / image.naturalWidth,
          maximumSample / image.naturalHeight
        );
        var sampleWidth = Math.max(
          1,
          Math.round(image.naturalWidth * sampleRatio)
        );
        var sampleHeight = Math.max(
          1,
          Math.round(image.naturalHeight * sampleRatio)
        );
        var canvas = document.createElement("canvas");
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;
        var context = canvas.getContext("2d", { willReadFrequently: true });

        if (!context) {
          resolve(smartFallbackBounds(image));
          return;
        }

        try {
          context.clearRect(0, 0, sampleWidth, sampleHeight);
          context.drawImage(image, 0, 0, sampleWidth, sampleHeight);
          var pixels = context.getImageData(
            0,
            0,
            sampleWidth,
            sampleHeight
          ).data;
          var left = sampleWidth;
          var top = sampleHeight;
          var right = -1;
          var bottom = -1;
          var alphaThreshold = 20;

          for (var y = 0; y < sampleHeight; y += 1) {
            for (var x = 0; x < sampleWidth; x += 1) {
              var alpha = pixels[(y * sampleWidth + x) * 4 + 3];
              if (alpha < alphaThreshold) continue;
              if (x < left) left = x;
              if (x > right) right = x;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
            }
          }

          if (right < left || bottom < top) {
            resolve(smartFallbackBounds(image));
            return;
          }

          resolve({
            x: left,
            y: top,
            width: right - left + 1,
            height: bottom - top + 1,
            canvasWidth: sampleWidth,
            canvasHeight: sampleHeight,
          });
        } catch (error) {
          /* A third-party image without canvas permission gets a safe normal
             fit instead of breaking the card or any other storefront code. */
          resolve(smartFallbackBounds(image));
        }
      }

      if (image.complete && image.naturalWidth) {
        measurePixels();
      } else {
        image.addEventListener("load", measurePixels, { once: true });
        image.addEventListener(
          "error",
          function () {
            resolve(smartFallbackBounds(image));
          },
          { once: true }
        );
      }
    });

    smartBoundsCache.set(key, promise);
    return promise;
  }

  function smartApplyFit(link, bounds) {
    var width = link.clientWidth;
    var height = link.clientHeight;
    if (!width || !height || !bounds.width || !bounds.height) return;

    var baseScale = Math.min(
      width / bounds.canvasWidth,
      height / bounds.canvasHeight
    );
    var visibleWidth = Math.max(1, bounds.width * baseScale);
    var visibleHeight = Math.max(1, bounds.height * baseScale);
    var artworkFill = parseFloat(link.dataset.artworkFill || "90") / 100;
    var backdropFill = parseFloat(link.dataset.backdropFill || "115") / 100;
    var desiredBlur = parseFloat(link.dataset.backdropBlur || "24");

    /* Foreground fits the detected artwork toward the requested width while
       retaining a little vertical safety so bundles and tall graphics do not
       get clipped. */
    var artworkScale = Math.min(
      (width * artworkFill) / visibleWidth,
      (height * 0.88) / visibleHeight
    );
    artworkScale = smartClamp(artworkScale, 0.65, 2.4);

    /* Backdrop covers the whole media box using the detected artwork bounds,
       then adds the user's fill amount. Narrow GUIs naturally zoom farther;
       full-frame images stay close to normal cover. */
    var backdropScale =
      Math.max(width / visibleWidth, height / visibleHeight) * backdropFill;
    backdropScale = smartClamp(backdropScale, 1, 7.5);

    link.style.setProperty("--kv-smart-art-scale", artworkScale.toFixed(4));
    link.style.setProperty("--kv-smart-bg-scale", backdropScale.toFixed(4));
    link.style.setProperty(
      "--kv-smart-bg-blur",
      Math.max(2, desiredBlur / backdropScale).toFixed(2) + "px"
    );
    link.dataset.kvSmartReady = "true";
    link.__kvSmartBounds = bounds;
  }

  function smartMeasureLink(link) {
    var image = link.querySelector(".kv-card__smart-source");
    if (!image) return;
    image.loading = "eager";
    smartReadBounds(image).then(function (bounds) {
      smartApplyFit(link, bounds);
    });
  }

  var smartIntersectionObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              smartIntersectionObserver.unobserve(entry.target);
              smartMeasureLink(entry.target);
            });
          },
          { rootMargin: "500px 0px" }
        )
      : null;

  function smartRegister(root) {
    var scope = root || document;
    var links = [];
    if (scope.matches && scope.matches("[data-kv-smart-fit]")) links.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll("[data-kv-smart-fit]").forEach(function (link) {
        links.push(link);
      });
    }

    links.forEach(function (link) {
      if (link.dataset.kvSmartObserved === "true") return;
      link.dataset.kvSmartObserved = "true";
      if (smartIntersectionObserver) {
        smartIntersectionObserver.observe(link);
      } else {
        smartMeasureLink(link);
      }
    });
  }

  smartRegister(document);

  if ("MutationObserver" in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) smartRegister(node);
        });
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && !node.isConnected) releaseCards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener("resize", function () {
    clearTimeout(smartResizeTimer);
    smartResizeTimer = setTimeout(function () {
      document
        .querySelectorAll('[data-kv-smart-ready="true"]')
        .forEach(function (link) {
          if (link.__kvSmartBounds) {
            smartApplyFit(link, link.__kvSmartBounds);
          }
        });
    }, 120);
  });

  document.addEventListener("shopify:section:load", function (event) {
    smartRegister(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    releaseCards(event.target);
  });
})();
